import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  createStyles,
  makeStyles,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  withStyles,
} from "@material-ui/core";
import {Pagination} from "@material-ui/lab";
import {useAppDispatch, useAppSelector} from "app/hooks";
import BACKGROUND from "assets/img/bg_list_test_again.png";
import {
  fetchListExamStudent,
  SelectFilterListExamStudent,
  SelectListExamStudent,
  selectLoadingListExamStudent,
} from "features/Home/pages/ListExamStudent/listExamStudentSlice";
import moment from "moment";
import React, {Fragment, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";
import {dateTimeToFormatYYYY} from "utils/dateTimeFormat";
import {setFilterListExam} from "../../managerExamListSlice";
import CreateExam from "./components/CreateExam";
import {deduplicateQuestions} from "utils/examPreview";
import managerTestApi from "api/managerTest";
import {QuestionByExamId, ListQuestionByExamIdResponse} from "models/managerTest";

export default function CreateExamAgain() {
  const useStyles = makeStyles(() => ({
    background: {
      backgroundImage: `url(${BACKGROUND})`,
      backgroundSize: "cover",
      backgroundPositionX: "right",
      backgroundRepeat: "no-repeat",
      height: 150,
      width: "100%",
      position: "relative",
      "& >h6": {
        position: "absolute",
        top: 50,
        left: 0,
        color: "#004673",
        fontSize: 25,
        fontWeight: 700,
      },
    },
    btn_next: {
      borderRadius: 20,
      background: "linear-gradient(360deg, #399BD9 0%, #83CFFF 172.67%)",
      color: "#fff",
      padding: "10px 15px",
    },
    container: {
      maxHeight: 500,
    },
  }));
  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        padding: "16px 5px",
        color: "#1B1B1B",
        fontSize: 11,
        fontWeight: 700,
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        borderBottom: "1px solid #777777",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 13,
        },
      },
      body: {
        padding: "16px 5px",
        fontSize: 11,
        borderRight: "1px solid rgba(224, 224, 224, 0.8)",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 13,
        },
      },
    })
  )(TableCell);

  const {t} = useTranslation();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const listExam = useAppSelector(SelectListExamStudent);
  const loading = useAppSelector(selectLoadingListExamStudent);
  const [searchParams, setSearchParams] = useSearchParams();
  const currentStep = Number(searchParams.get("step") || "1");

  const [arrIdQuestion, setArrIdQuestion] = useState<any[]>(() => {
    try {
      const saved = sessionStorage.getItem("gpet_create_again_exams");
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  });
  const filter = useAppSelector(SelectFilterListExamStudent);

  useEffect(() => {
    try {
      sessionStorage.setItem("gpet_create_again_exams", JSON.stringify(arrIdQuestion));
    } catch (e) {}
  }, [arrIdQuestion]);

  useEffect(() => {
    if (currentStep > 1 && (!arrIdQuestion || arrIdQuestion.length === 0)) {
      setSearchParams({step: "1"}, {replace: true});
    }
  }, [currentStep, arrIdQuestion, setSearchParams]);

  useEffect(() => {
    dispatch(
      fetchListExamStudent({...filter, toDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss")})
    );
  }, [dispatch, filter]);

  const [questionStats, setQuestionStats] = useState<{
    total: number;
    duplicate: number;
    unique: number;
    loading: boolean;
  }>({ total: 0, duplicate: 0, unique: 0, loading: false });

  useEffect(() => {
    if (!arrIdQuestion || arrIdQuestion.length === 0) {
      setQuestionStats({ total: 0, duplicate: 0, unique: 0, loading: false });
      return;
    }
    (async () => {
      try {
        setQuestionStats((prev) => ({ ...prev, loading: true }));
        const examIds = arrIdQuestion.map((x) => x.id).join(",");
        const res: ListQuestionByExamIdResponse<QuestionByExamId> =
          await managerTestApi.getQuestionByMutipleExamId(examIds);
        if (res.responseCode === "00" && res.questions) {
          const rawQuestions = res.questions;
          const uniqueQuestions = deduplicateQuestions(rawQuestions);
          setQuestionStats({
            total: rawQuestions.length,
            duplicate: rawQuestions.length - uniqueQuestions.length,
            unique: uniqueQuestions.length,
            loading: false,
          });
        }
      } catch (e) {
        setQuestionStats((prev) => ({ ...prev, loading: false }));
      }
    })();
  }, [arrIdQuestion]);

  const handleChangePage = (page: number) => {
    dispatch(
      setFilterListExam({
        ...filter,
        page: page - 1,
      })
    );
  };

  const handleAddExam = (event: any, exam: any) => {
    setArrIdQuestion((prevState: any) => {
      const foundIdx = arrIdQuestion?.findIndex((x) => x.id === exam?.id);
      if (foundIdx > -1) {
        const copy = [...prevState];
        copy.splice(foundIdx, 1);
        return copy;
      }
      if (arrIdQuestion.length > 0 && arrIdQuestion[0].type !== exam.type) {
        toast.error(`${t("managerTest.vuilongchonhinhthuccauhoi")}`);
        return [...prevState];
      }
      return [...prevState, {type: exam.type, id: exam.id}];
    });
  };

  const handleNextToStep2 = () => {
    if (!arrIdQuestion || arrIdQuestion.length === 0) {
      toast.error(t("managerTest.vuilongchondethicu") || "Vui lòng chọn ít nhất 1 đề thi cũ");
      return;
    }
    setSearchParams({step: "2"});
  };

  return (
    <Box>
      <Stepper activeStep={Math.min(Math.max(currentStep - 1, 0), 2)} alternativeLabel style={{marginBottom: 20, backgroundColor: "transparent"}}>
        <Step>
          <StepLabel>{t("managerTest.step.chondethicu")}</StepLabel>
        </Step>
        <Step>
          <StepLabel>{`2. ${t("managerTest.step.cauhinhbaithi")}`}</StepLabel>
        </Step>
        <Step>
          <StepLabel>{`3. ${t("managerTest.step.xemtruocvanop")}`}</StepLabel>
        </Step>
      </Stepper>

      {currentStep >= 2 ? (
        <Fragment>
          <Box className={classes.background}>
            <Typography variant="subtitle2">
              {t("managerTest.nhungcauhoidethicu").toUpperCase()}
            </Typography>
          </Box>
          <CreateExam
            setShowCreateExam={(val: boolean) => setSearchParams({step: val ? "2" : "1"})}
            arrIdQuestion={arrIdQuestion.map((item) => item.id)}
            type={arrIdQuestion.every((item) => item.type === "CHOICES") ? "CHOICES" : "TYPING"}
          />
        </Fragment>
      ) : (
        <Fragment>
          <Box className={classes.background}>
            <Typography variant="subtitle2">
              {t("managerTest.danhsachdethicu").toUpperCase()}
            </Typography>
          </Box>

          <Box>
            {loading ? (
              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={6} style={{ minHeight: "250px" }}>
                <CircularProgress style={{ color: "#399BD9" }} size={40} />
                <Typography variant="body2" style={{ marginTop: 12, color: "#004673", fontWeight: 600 }}>
                  {t("managerTest.dangtaidanhsachdethi")}
                </Typography>
              </Box>
            ) : (
              <Fragment>
                {arrIdQuestion.length > 0 && (
                  <Paper style={{ padding: "12px 20px", marginBottom: 16, backgroundColor: "#EBF3FA", borderRadius: 10, border: "1px solid #B8D8F0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 12 }}>
                      <Typography variant="subtitle2" style={{ fontWeight: 700, color: "#004673", marginRight: 8 }}>
                        {t("managerTest.thongkecauhoi")}:
                      </Typography>
                      <Chip label={`${t("managerTest.dachondethi")}: ${arrIdQuestion.length}`} color="primary" variant="outlined" style={{ fontWeight: 600 }} size="small" />
                      <Chip label={`${t("managerTest.tongsocauhoigoc")}: ${questionStats.total}`} style={{ backgroundColor: "#137BBD", color: "#fff", fontWeight: 600 }} size="small" />
                      <Chip label={`${t("managerTest.socautrunglap")}: ${questionStats.duplicate}`} style={{ backgroundColor: questionStats.duplicate > 0 ? "#E53935" : "#757575", color: "#fff", fontWeight: 600 }} size="small" />
                      <Chip label={`${t("managerTest.socauconlai")}: ${questionStats.unique}`} style={{ backgroundColor: "#43A047", color: "#fff", fontWeight: 600 }} size="small" />
                    </Box>
                    {questionStats.loading && <CircularProgress size={20} style={{ color: "#004673" }} />}
                  </Paper>
                )}
                <TableContainer component={Paper} className={classes.container}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="center" width="70px">
                          {t("stt")}
                        </StyledTableCell>
                        <StyledTableCell align="center" width="150px">
                          {t("managerTest.ngaytaode")}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {t("managerTest.tieudebaithi")}
                        </StyledTableCell>
                        <StyledTableCell align="center" width="100px">
                          {t("managerTest.socauhoi")}
                        </StyledTableCell>
                        <StyledTableCell align="center" width="120px">
                          {t("managerTest.hinhthucthi")}
                        </StyledTableCell>
                        <StyledTableCell align="center" width="120px">
                          {t("managerTest.thoigian")}
                        </StyledTableCell>
                        <StyledTableCell align="center" width="100px">
                          {t("managerTest.tongdiem")}
                        </StyledTableCell>
                        <StyledTableCell align="center" width="100px">
                          {t("managerTest.luachon")}
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listExam?.basicExamResponses?.content?.map((exam, index) => (
                        <TableRow key={exam.id}>
                          <StyledTableCell align="center" component="th" scope="exam">
                            {listExam.basicExamResponses?.size * listExam.basicExamResponses?.number + index + 1}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {dateTimeToFormatYYYY(exam?.createdDate)}
                          </StyledTableCell>
                          <StyledTableCell align="center">{exam?.title}</StyledTableCell>
                          <StyledTableCell align="center">{exam?.questionNumber}</StyledTableCell>
                          <StyledTableCell align="center">
                            {exam?.type === "CHOICES" ? (
                              <Typography variant="subtitle2" style={{color: "#137BBD"}}>
                                {t("managerTest.tracnghiem")}
                              </Typography>
                            ) : (
                              <Typography variant="subtitle2" style={{color: "#F99600"}}>
                                {t("managerTest.tuluan")}
                              </Typography>
                            )}
                          </StyledTableCell>
                          <StyledTableCell align="center">{exam?.examTime}</StyledTableCell>
                          <StyledTableCell align="center">{exam?.totalPoint}</StyledTableCell>
                          <StyledTableCell align="center">
                            <Box display="flex" justifyContent="center">
                              <Checkbox
                                color="primary"
                                onChange={(event) => handleAddExam(event, exam)}
                                inputProps={{"aria-label": "primary checkbox"}}
                                checked={arrIdQuestion?.some((item) => item.id === exam?.id)}
                              />
                            </Box>
                          </StyledTableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box
                  mt={3}
                  display="flex"
                  justifyContent={
                    listExam?.basicExamResponses?.totalPages > 1 ? "space-between" : "flex-end"
                  }
                >
                  {listExam?.basicExamResponses?.totalPages > 1 && (
                    <Pagination
                      count={Math.ceil(
                        listExam?.basicExamResponses?.totalElements / listExam?.basicExamResponses?.size
                      )}
                      page={listExam?.basicExamResponses?.number + 1}
                      variant="outlined"
                      color="primary"
                      shape="rounded"
                      onChange={(e, page) => handleChangePage(page)}
                    />
                  )}
                  <Button className={classes.btn_next} onClick={handleNextToStep2}>
                    {t("managerTest.tieptheo")}
                  </Button>
                </Box>
              </Fragment>
            )}
          </Box>
        </Fragment>
      )}
    </Box>
  );
}
